import { createFeatureSelector } from '@ngrx/store';
import { IMsalAuth } from '../actions/msalAuth.actions';

export const selectMsalAuth = createFeatureSelector<IMsalAuth>('msalAuth');
